import type { OfferCountOptions, OfferCreateDto, OfferDto, OfferFullDto, OfferIncludeOptions, OfferQueryOptions, OfferUpdateDto } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { EnumDto, PagedResultWithStatsDto } from '../common/models';

@Injectable({
  providedIn: 'root',
})
export class OfferService {
  apiName = 'Default';

  create = (input: OfferCreateDto, cancellationToken?: any) =>
    this.restService.request<any, OfferDto>({
      method: 'POST',
      url: `/api/app/offer`,
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string, cancellationToken?: any) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/offer/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string, options?: OfferIncludeOptions, cancellationToken?: any) =>
    this.restService.request<any, OfferDto>({
      method: 'GET',
      url: `/api/app/offer/${id}`,
      params: { filterStore: options?.filterStore, includePreset: options?.includePreset, includeAppStoreOffers: options?.includeAppStoreOffers },
    },
    { apiName: this.apiName });

  getCount = (options?: OfferCountOptions, cancellationToken?: any) =>
    this.restService.request<any, number>({
      method: 'GET',
      url: `/api/app/offers/count`,
      params: { searchText: options?.searchText, filterName: options?.filterName, filterType: options?.filterType, filterIsPromo: options?.filterIsPromo, filterIapId: options?.filterIapId, filterPriceMin: options?.filterPriceMin, filterPriceMax: options?.filterPriceMax, filterStore: options?.filterStore },
    },
    { apiName: this.apiName });

  getList = (options?: OfferQueryOptions, cancellationToken?: any) =>
    this.restService.request<any, PagedResultDto<OfferFullDto>>({
      method: 'GET',
      url: `/api/app/offers`,
      params: { searchText: options?.searchText, filterName: options?.filterName, filterType: options?.filterType, filterIsPromo: options?.filterIsPromo, filterIapId: options?.filterIapId, filterPriceMin: options?.filterPriceMin, filterPriceMax: options?.filterPriceMax, filterStore: options?.filterStore, includePreset: options?.includePreset, includeAppStoreOffers: options?.includeAppStoreOffers, maxResultCount: options?.maxResultCount, sorting: options?.sorting, skipCount: options?.skipCount },
    },
    { apiName: this.apiName });

  getListWithStats = (options: OfferQueryOptions, cancellationToken?: any) =>
    this.restService.request<any, PagedResultWithStatsDto<OfferFullDto>>({
      method: 'GET',
      url: `/api/app/offers/with-stats`,
      params: { searchText: options?.searchText, filterName: options?.filterName, filterType: options?.filterType, filterIsPromo: options?.filterIsPromo, filterIapId: options?.filterIapId, filterPriceMin: options?.filterPriceMin, filterPriceMax: options?.filterPriceMax, filterStore: options?.filterStore, includePreset: options?.includePreset, includeAppStoreOffers: options?.includeAppStoreOffers, maxResultCount: options?.maxResultCount, sorting: options?.sorting, skipCount: options?.skipCount },
    },
    { apiName: this.apiName });

  getOfferTypes = () =>
    this.restService.request<any, EnumDto[]>({
      method: 'GET',
      url: `/api/app/lookups/offer-types`,
    },
    { apiName: this.apiName });

  update = (id: string, input: OfferUpdateDto, cancellationToken?: any) =>
    this.restService.request<any, OfferDto>({
      method: 'PUT',
      url: `/api/app/offer/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
